<template>
  <div>
    <div class="mt-3">
      Emotions:
      <v-icon
        small
        color="blue"
        v-on:click.stop.prevent="showEmotionPopup = !showEmotionPopup"
        title="Emotion description"
        class="description-icon"
        >fas fa-info-circle</v-icon
      >
      <SimpleDialog :open="showEmotionPopup" title="Events AI Emotions">
        <p v-html="emotionDescription"></p>
      </SimpleDialog>
    </div>
    <div class="emotions-filter-container" :key="updateTimestamp">
      <div v-for="emotion in emotionOptions" :key="emotion">
        <v-checkbox
          outlined
          small
          hide-details
          v-model="selection"
          :value="emotion"
          :label="getLabel(emotion)"
          @click="toggleSelection(emotion)"
        >
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { formatBigNumber } from "@/common/basic.utilities";
import { EVENT_ACTIONS, SEARCH_CATEGORIES } from "@/common/constants/analytics";
import { EVENTS_AI_EMOTIONS } from "@/common/constants/events";
import { emotionDescription } from "@/common/constants/descriptions";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};
export default {
  name: "SearchFilterEmotions",
  components: {
    SimpleDialog: () => import("@/components/common/dialogs/SimpleDialog"),
  },
  props: {
    filterCounts: {
      type: Object,
      default() {
        const ret = {};
        const emotions = EVENTS_AI_EMOTIONS?.slice();
        emotions?.forEach((e) => {
          ret[e] = null;
        });
        return ret;
      },
    },
    incomingSelection: {
      type: Array,
    },
  },
  data: function () {
    return {
      showEmotionPopup: false,
      selection: [],
      emotionOptions: EVENTS_AI_EMOTIONS.slice(),
      updateTimestamp: null,
      emotionDescription,
    };
  },
  mounted() {
    if (this.incomingSelection?.length) {
      this.selection = this.incomingSelection;
    }
  },
  methods: {
    toggleSelection() {
      if (this.selection?.length) {
        this.handlePageTrackerEvent(
          SEARCH_CATEGORIES.live_search_emotions,
          EVENT_ACTIONS.selected,
          "Emotions - " + this.selection.join(",")
        );
      } else {
        this.handlePageTrackerEvent(
          SEARCH_CATEGORIES.live_search_emotions,
          EVENT_ACTIONS.clear,
          "Emotions"
        );
      }

      this.$emit(EMITTED_ACTIONS.CHANGE, this.selection);
    },
    getCount(type) {
      const count =
        typeof this.filterCounts[type] === "number"
          ? this.filterCounts[type]
          : null;

      return formatBigNumber(count)?.toString() || "";
    },
    getLabel(emotion) {
      let label = emotion;
      if (this.getCount(emotion)) {
        label += ` (${this.getCount(emotion)})`;
      }
      return label;
    },
  },
  watch: {
    incomingSelection: {
      handler(newVal) {
        if (newVal !== this.selection) {
          this.selection = newVal;
          this.updateTimestamp = new Date().toISOString(); //Force an update of the component
        }
      },
    },
  },
};
</script>

<style>
.emotions-filter-container {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 5px;
  font-size: 10px;
  margin-left: -3px;
}
.emotions-filter-container .v-input .v-label {
  color: #1c1c1c;
  font-size: 13px !important;
  text-transform: capitalize;
}
.emotions-filter-container .v-input--selection-controls__ripple,
.emotions-filter-container
  .v-input--selection-controls__input
  input[role="checkbox"] {
  width: 22px;
  height: 22px;
  left: -7px;
  top: -7px;
}

.emotions-filter-container .v-icon {
  font-size: 20px;
}
.emotions-filter-container .v-input--selection-controls.v-input {
  margin-top: 0;
}
</style>
